/*
 * File: UITextHeader.js
 * Project: mp-mobile-app
 *
 * Created by Rob Rothe
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Creates a subheader with text in it
 */
import React from "react";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";

const styles = theme => ({
  root: {
    marginBottom: 0,
    padding: theme.spacing(1.5),
    backgroundColor: theme.palette.common.headerbg,
    borderBottom: "1px solid" + theme.palette.common.border,
    borderTop: "1px solid" + theme.palette.common.border,
    position: "relative",
    color: theme.palette.common.title
  }
});

const UITextHeader = ({ classes, title }) => {
  return (
    <Typography variant="h5" className={classes.root}>
      {title}
    </Typography>
  );
};

UITextHeader.propTypes = {
  classes: PropTypes.object.isRequired,
  title: PropTypes.node.isRequired
};

export default withStyles(styles)(UITextHeader);
